export const mainNum = 10
export const DEFAULT_COLOUR_ID = '0000000000'
export const SPEC_VALUE_MAX_LENGTH_NUM = 50

/**
 * 产品名称 标品
 */
export const SPU_TYPE_PRODUCE_NAME = 8
/**
 * 型号 标品
 */
export const SPU_TYPE_MODEL_NUMBER = 3

// 重置规格图
export const RESET_DISPLAY_IMAGES = 999
